<template>
  <QuestionBody :qsNumber="qsNumber" :nextPage="nextPage" :navigateType="navigateType" :content="content" />
</template>

<script>
import QuestionBody from '@/layout/QuestionBody.vue'
export default {
  name: "Qs1-5",
  components: {
    QuestionBody
  },
  data() {
    return {
      qsNumber: 5,
      nextPage: '/questionnaire/section1/6',
      navigateType: 'CLICK_ANY_BTN',
      content: {
        componentsType: {
          pc: 'longBtn',
          mobile: 'normalBtn'
        },
        titleIcon: require('@/assets/icon/questionIcon/Prepare_for_pregnancy.png'),
        mainTitle: 'How long have you been trying to conceive?',
        btn: [
          [
            {
              text: '<3 mos.',
            }
          ],[
            {
              text: '3-6 mos.',
            }
          ],[
            {
              text: '>6 mos.',
            }
          ]
        ]
      }
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
</style>
